import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { IHeader, translate } from '../../libs/utils';
import Table from '../../components/table/Table';
import { useAppDispatch } from '../../redux';
import { useSelector } from 'react-redux';
import TableBody from '../../components/admin-users/TableBody';
import { Box } from '@mui/material';
import TableButton from '../../components/table/TableButton';
import { getAdminUsers } from '../../redux/admin-users/action';
import { adminUsersSelector } from '../../redux/admin-users/selectors';
import { IData } from '../../redux/admin-users/types';
import { calculateTotalPage } from '../../libs/utils/calculateTotalPage';
import Pagination from '../../components/table/Pagination';
import { useNavigate } from 'react-router-dom';

const headers: IHeader[] = [
  {
    id: 'dental_registration_number',
    label: translate('administrator.list.table.dental_registration_number'),
  },
  { id: 'name', label: translate('administrator.list.table.name') },
  { id: 'email', label: translate('administrator.list.table.email') },
  {
    id: 'birth_date',
    label: translate('administrator.list.table.date_of_birth'),
  },
  {
    id: 'edit',
    label: translate('administrator.list.table.edit_action'),
  },
];

const AdminUsersScreen: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const adminUsersData: IData = useSelector(adminUsersSelector);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const redirectToCreateAdminScreen = () => navigate('/role/create');

  const handleClickEditAdmin = (adminId: number) =>
    navigate(`/role/${adminId}`);

  const handleOnChangePage = (page: number) => {
    setCurrentPage(page);
    dispatch(getAdminUsers({ page: page }));
  };

  useEffect(() => {
    dispatch(getAdminUsers({ page: currentPage }));
  }, [currentPage, dispatch]);

  return (
    <Layout title={translate('administrator.list.title')}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          bgcolor: 'background.paper',
          py: 2,
          borderRadius: 1,
          mb: '5px',
          mt: '-35px',
        }}
      >
        <Box>
          <TableButton
            label={translate('button.add')}
            onClick={redirectToCreateAdminScreen}
          />
        </Box>
      </Box>
      <Table headers={headers}>
        <TableBody
          data={adminUsersData.items}
          onClickEdit={handleClickEditAdmin}
        />
      </Table>
      <Pagination
        total={calculateTotalPage(adminUsersData.total)}
        page={adminUsersData.current_page}
        textTotal=""
        onChangePage={handleOnChangePage}
      />
    </Layout>
  );
};
export default AdminUsersScreen;
